import { Banner, DevelopmentProcess, Faq, NativeAppDevelopmentCostAndTimeLine, NativeAppDevelopmentServicesOffer, NativeVSCrossPlatform, WhatAreNativeApps, WhyChooseNativeAppDevelopment } from "./components"

 function NativeAppDevelopment(){
    return(
  <div className="  space-y-20 md:space-y-36 mb-20 md:mb-32">
     <Banner/>
     <WhatAreNativeApps/>
    <WhyChooseNativeAppDevelopment/>
    <NativeVSCrossPlatform/>
    <NativeAppDevelopmentServicesOffer/>
    <NativeAppDevelopmentCostAndTimeLine/>
    <DevelopmentProcess/>
    <Faq/>
     </div>
    )
 }

 export default NativeAppDevelopment